const STORAGE_KEY = 'dismissedBannerId';

export const landingPageBannerStore = {
  bannerId: null,
  visible: true,
  initialized: false,

  init(bannerId) {
    if (this.initialized && this.bannerId === bannerId) return;

    this.bannerId = bannerId;
    this.initialized = true;

    try {
      this.visible = localStorage.getItem(STORAGE_KEY) !== String(bannerId);
    } catch {
      this.visible = true;
    }

    if (!this.visible) {
      this.syncLayout();
    }
  },

  dismiss() {
    if (this.bannerId == null) return;

    try {
      localStorage.setItem(STORAGE_KEY, String(this.bannerId));
    } catch {
      // Ignore quota / private-mode errors; still hide for this page load.
    }

    this.visible = false;
    this.syncLayout();
  },

  syncLayout() {
    document.querySelector('#chat-iframe')?.classList.remove('banner-shown');
  },
};
